import axios from "axios";
import store from "../store";
import msal from "./msal";

const API_URL = process.env.VUE_APP_ADMIN_API_URL;

function getConfig(extraHeaders = {}) {
  return {
    headers: {
      Authorization: "Bearer " + store.state.tokenId,
      'X-Version': window.location.href.split('/').indexOf('v2') === -1 ? 'v1' : 'v2',
      ...extraHeaders
    }
  };
}

async function getOrders() {
  await msal.refreshToken();
  const response = await axios.get(API_URL + "/orders", getConfig());
  return response.data;
}

async function getCarts() {
  await msal.refreshToken();
  const response = await axios.get(API_URL + "/carts", getConfig());
  return response.data;
}

async function getActiveOrders() {
  await msal.refreshToken();
  const response = await axios.get(API_URL + "/orders/active", getConfig());
  console.log(response);
  return response.data;
}

async function getOpenOrders() {
  await msal.refreshToken();
  const response = await axios.get(API_URL + "/orders/open", getConfig());
  console.log(response);
  return response.data;
}

async function getIssuesOrders() {
  await msal.refreshToken();
  const response = await axios.get(API_URL + "/orders/issues", getConfig());
  // console.log(response);
  return response.data;
}

async function getPinnedOrders() {
  await msal.refreshToken();
  const response = await axios.get(API_URL + "/orders/pinned", getConfig());
  // console.log(response);
  return response.data;
}

async function getClosedOrders() {
  await msal.refreshToken();
  const response = await axios.get(API_URL + "/orders/closed", getConfig());
  console.log(response);
  return response.data;
}

async function getCancelledOrders() {
  await msal.refreshToken();
  const response = await axios.get(API_URL + "/orders/cancelled", getConfig());
  return response.data;
}

async function getDisputedOrders() {
  await msal.refreshToken();
  const response = await axios.get(API_URL + "/orders/disputed", getConfig());
  return response.data;
}

async function getDrafts() {
  await msal.refreshToken();
  const response = await axios.get(API_URL + "/orders/drafts", getConfig());
  return response.data;
}

async function getOrder(orderId) {
  await msal.refreshToken();
  const response = await axios.get(API_URL + "/orders/" + orderId, getConfig());
  return response.data;
}

async function getCart(cartId) {
  await msal.refreshToken();
  const response = await axios.get(API_URL + "/carts/" + cartId, getConfig());
  return response.data;
}

async function getCompany(companyId) {
  await msal.refreshToken();
  const response = await axios.get(API_URL + "/company/" + companyId, getConfig());
  return response.data;
}

async function saveCompany(companyId, data) {
  await msal.refreshToken();
  const response = await axios.put(API_URL + "/company/" + companyId, data, getConfig());
  return response.data;
}

async function saveCompanyJobConfig(companyId, data) {
  await msal.refreshToken();
  const response = await axios.put(API_URL + "/company/" + companyId + '/jobs', data, getConfig());
  return response.data;
}

async function getCompanyMembers(companyId) {
  await msal.refreshToken();
  const response = await axios.get(API_URL + "/company/" + companyId + '/members', getConfig());
  return response.data;
}


async function getCompanyContacts(companyId) {
  await msal.refreshToken();
  const response = await axios.get(API_URL + "/company/" + companyId + '/contacts', getConfig());
  return response.data;
}

async function getCompanyInvoices(companyId) {
  await msal.refreshToken();
  const response = await axios.get(API_URL + "/company/" + companyId + '/invoices', getConfig());
  return response.data;
}

async function generateCompanyReport(companyId, month) {
  await msal.refreshToken();
  const response = await axios.post(API_URL + "/company/" + companyId + '/report', { month }, getConfig());
  return response.data;
}

async function saveNote(collection, objectId, body) {
  await msal.refreshToken();
  const response = await axios.post(API_URL + "/notes/" + collection + '/' + objectId, body, getConfig());
  return response.data;
}

async function addNoteMessage(collection, objectId, body) {
  await msal.refreshToken();
  const response = await axios.post(API_URL + "/notes/" + collection + '/' + objectId + '/message', body, getConfig());
  return response.data;
}

async function createTag(body) {
  await msal.refreshToken();
  const response = await axios.post(API_URL + "/tags", body, getConfig());
  return response.data;
}

async function registerPayment(companyId, reportId, params) {
  await msal.refreshToken();
  const response = await axios.put(API_URL + "/company/" + companyId + '/report/' + reportId, params, getConfig());
  return response.data;
}

async function getCompanyReports(companyId) {
  await msal.refreshToken();
  const response = await axios.get(API_URL + "/company/" + companyId + '/reports', getConfig());
  return response.data;
}

async function sendCompanyReport(reportId) {
  await msal.refreshToken();
  const response = await axios.get(API_URL + "/reports/" + reportId + '/send', getConfig());
  return response.data; 
}

async function overrideVerification(userId) {
  await msal.refreshToken();
  const response = await axios.post(API_URL + "/users/" + userId + "/awaitingVerification", {}, getConfig());
  return response.data;
}

async function updateUserAddress(userId, address) {
  await msal.refreshToken();
  const response = await axios.put(API_URL + "/users/" + userId + "/address", {address}, getConfig());
  return response.data;
}

async function updatePhoneNumber(userId, phoneNumber) {
  await msal.refreshToken();
  const response = await axios.put(API_URL + "/users/" + userId + "/phoneNumber", {phoneNumber}, getConfig());
  return response.data;
}

async function addDebt(userId, params) {
  await msal.refreshToken();
  const response = await axios.post(API_URL + "/users/" + userId + "/debt", params, getConfig());
  return response.data;
}

async function addCompanyDebt(userId, params) {
  await msal.refreshToken();
  const response = await axios.post(API_URL + "/companies/" + userId + "/debt", params, getConfig());
  return response.data;
}

async function removeVerification(userId, {reason}) {
  await msal.refreshToken();
  const response = await axios.post(API_URL + "/users/" + userId + "/unverify", {reason}, getConfig());
  return response.data;
}

async function disableOrders(userId) {
  await msal.refreshToken();
  const response = await axios.post(API_URL + "/users/" + userId + "/disableOrders", {}, getConfig());
  return response.data;
}

async function removePassbase(userId) {
  await msal.refreshToken();
  const response = await axios.delete(API_URL + "/users/" + userId + "/passbaseAuthKey", getConfig());
  return response.data;
}

async function setAsSaasCandidate(userId) {
  await msal.refreshToken();
  const response = await axios.post(API_URL + "/users/" + userId + "/saasCandidate", {}, getConfig());
  return response.data;
}

async function giveDiscount(userId, value, currency) {
  await msal.refreshToken();
  const response = await axios.post(API_URL + "/users/" + userId + "/discount", { value, currency }, getConfig());
  return response.data;
}

async function getTask(taskId) {
  await msal.refreshToken();
  const response = await axios.get(API_URL + "/tasks/" + taskId, getConfig());
  return response.data;
}

async function getTasks() {
  await msal.refreshToken();
  const response = await axios.get(API_URL + "/tasks", getConfig());
  return response.data;
}

async function getNews() {
  await msal.refreshToken();
  const response = await axios.get(API_URL + "/news", getConfig());
  return response.data;
}

async function getTerms() {
  await msal.refreshToken();
  const response = await axios.get(API_URL + "/terms", getConfig());
  return response.data;
}

async function getArticles() {
  await msal.refreshToken();
  const response = await axios.get(API_URL + "/articles", getConfig());
  return response.data;
}

async function getTasksByIds(ids) {
  await msal.refreshToken();
  const response = await axios.post(API_URL + "/tasksBatch", {ids}, getConfig());
  return response.data;
}

async function sendNotifications(params) {
  const {text, title, segments, testUserId} = params;
  if (!text && !title) {
    throw 'Can not send notification without content';
  }
  if (!testUserId && !Object.keys(segments).length) {
    throw 'Can not send notifications to nobody';
  }
  console.log('sending notification"', text, '" to ', testUserId, segments);
  await msal.refreshToken();
  const response = await axios.post(API_URL + "/notificationsBatch", params, getConfig());
  return response.data;
}

async function getReviewsByIds(ids = []) {
  if (!ids.length) {
    return [];
  }
  await msal.refreshToken();
  const response = await axios.post(API_URL + "/reviewsBatch", {ids}, getConfig());
  return response.data;
}

async function getInvoicesByIds(ids = []) {
  if (!ids.length) {
    return [];
  }
  await msal.refreshToken();
  const response = await axios.post(API_URL + "/invoicesBatch", {ids}, getConfig());
  return response.data;
}

async function removeDeletionRequest(userId) {
  await msal.refreshToken();
  const response = await axios.post(
    API_URL + "/users/" + userId + "/removeDeletionRequest",
    {},
    getConfig()
  );
  return response.data;
}

async function verifyUser(userId) {
  await msal.refreshToken();
  const response = await axios.get(
    API_URL + "/users/" + userId + "/verify",
    getConfig()
  );
  return response.data;
}

async function promoteUser(userId) {
  await msal.refreshToken();
  const response = await axios.post(
    API_URL + "/users/" + userId + "/promote",
    {},
    getConfig()
  );
  return response.data;
}

async function inititateB2bOnboarding(userId) {
  await msal.refreshToken();
  const response = await axios.post(
    API_URL + "/users/" + userId + "/initiateB2bOnboarding",
    {},
    getConfig()
  );
  return response.data;
}

async function removeB2bStatus(userId) {
  await msal.refreshToken();
  const response = await axios.post(
    API_URL + "/users/" + userId + "/removeB2bStatus",
    {},
    getConfig()
  );
  return response.data;
}

async function setBusinessSkills(userId, params) {
  await msal.refreshToken();
  const response = await axios.post(
    API_URL + "/users/" + userId + "/skills",
    params,
    getConfig()
  );
  return response.data;
}

async function sendInvoice(orderId) {
  await msal.refreshToken();
  const response = await axios.get(
    API_URL + "/orders/" + orderId + "/sendInvoice",
    getConfig()
  );
  return response.data;
}

async function sendPayment(orderId) {
  await msal.refreshToken();
  const response = await axios.get(
    API_URL + "/orders/" + orderId + "/sendPayment",
    getConfig()
  );
  return response.data;
}

async function transfer(orderId, params) {
  await msal.refreshToken();
  const response = await axios.post(
    API_URL + "/orders/" + orderId + "/transfer",
    params,
    getConfig()
  );
  return response.data;
}

async function cancelOrder(orderId, params) {
  await msal.refreshToken();
  const response = await axios.post(
    API_URL + "/orders/" + orderId + "/cancel",
    params,
    getConfig()
  );
  return response.data;
}

async function cancelAutopayment(orderId, params) {
  await msal.refreshToken();
  const response = await axios.post(
    API_URL + "/orders/" + orderId + "/cancelPayment",
    params,
    getConfig()
  );
  return response.data;
}

async function assignPhoneNumber(taskId) {
  await msal.refreshToken();
  const response = await axios.post(
    API_URL + "/tasks/" + taskId + "/assignPhoneNumber",
    {},
    getConfig()
  );
  return response.data;
}

async function rejectTask(taskId, params) {
  await msal.refreshToken();
  const response = await axios.post(
    API_URL + "/tasks/" + taskId + "/reject",
    params,
    getConfig()
  );
  return response.data;
}

async function reopenTask(taskId, params) {
  await msal.refreshToken();
  const response = await axios.post(
    API_URL + "/tasks/" + taskId + "/reopen",
    params,
    getConfig()
  );
  return response.data;
}

async function getSkillDates(skillId, params) {
  await msal.refreshToken();
  const response = await axios.post(
    API_URL + "/dates/" + skillId,
    params,
    getConfig()
  );
  return response.data;
}

async function getProDates(proId, params) {
  await msal.refreshToken();
  const response = await axios.post(
    API_URL + "/pro-dates/" + proId,
    params,
    getConfig()
  );
  return response.data;
}

async function getLocations(address) {
  await msal.refreshToken();
  const response = await axios.post(
    API_URL + "/locations",
    {address},
    getConfig()
  );
  return response.data;
}

async function updateOrderLocation(orderId, location) {
  await msal.refreshToken();
  const response = await axios.post(
    API_URL + "/orders/" + orderId + "/location",
    location,
    getConfig()
  );
  return response.data;
}

async function charge(orderId) {
  await msal.refreshToken();
  const response = await axios.post(
    API_URL + "/orders/" + orderId + "/charge",
    {},
    getConfig()
  );
  return response.data;
}

async function getUsers() {
  await msal.refreshToken();
  const response = await axios.get(API_URL + "/users", getConfig());
  return response.data;
}

async function getUsersByIds(ids) {
  await msal.refreshToken();
  const response = await axios.post(API_URL + "/usersBatch", { ids }, getConfig());
  return response.data;
}

async function resendInvite(companyId, email) {
  await msal.refreshToken();
  const response = await axios.post(API_URL + "/company/" + companyId + "/invite", { email }, getConfig());
  return response.data;
}

async function getContactsByIds(ids) {
  await msal.refreshToken();
  const response = await axios.post(API_URL + "/contactsBatch", { ids }, getConfig());
  return response.data;
}

async function getContacts() {
  await msal.refreshToken();
  const response = await axios.get(API_URL + "/contacts", getConfig());
  return response.data;
}

async function getAllUsers() {
  await msal.refreshToken();
  const response = await axios.get(API_URL + "/users/export", getConfig());
  return response.data;
}

async function getVerifications() {
  await msal.refreshToken();
  const response = await axios.get(API_URL + "/users/verifications", getConfig());
  return response.data;
}

async function searchUsers(params) {
  await msal.refreshToken();
  const response = await axios.post(API_URL + "/users/search", params, getConfig());
  return response.data;
}

async function searchUsersByLocation(params) {
  await msal.refreshToken();
  const response = await axios.post(API_URL + "/users/candidates", params, getConfig());
  return response.data;
}

async function searchOrders(params) {
  await msal.refreshToken();
  const response = await axios.post(API_URL + "/orders/search", params, getConfig());
  return response.data;
}

async function getPros() {
  await msal.refreshToken();
  const response = await axios.get(API_URL + "/users/pros", getConfig());
  return response.data;
}

async function getProsStartedVerification() {
  await msal.refreshToken();
  const response = await axios.get(API_URL + "/users/startedVerification", getConfig());
  return response.data;
}

async function getClients() {
  await msal.refreshToken();
  const response = await axios.get(API_URL + "/users/clients", getConfig());
  return response.data;
}

async function getOffenders() {
  await msal.refreshToken();
  const response = await axios.get(API_URL + "/users/offenders", getConfig());
  return response.data;
}

async function getDebtors() {
  await msal.refreshToken();
  const response = await axios.get(API_URL + "/users/debtors", getConfig());
  return response.data;
}

async function getCompanies() {
  await msal.refreshToken();
  const response = await axios.get(API_URL + "/companies", getConfig());
  console.log('response', response);
  return response.data;
}

async function getUser(userId) {
  await msal.refreshToken();
  const response = await axios.get(API_URL + "/users/" + userId, getConfig());
  return response.data;
}

async function getJobs() {
  await msal.refreshToken();
  const response = await axios.get(API_URL + "/jobs", getConfig());
  return response.data;
}

async function getServices() {
  await msal.refreshToken();
  const response = await axios.get(API_URL + "/services", getConfig());
  return response.data;
}

async function getPlatformConfig() {
  await msal.refreshToken();
  const response = await axios.get(API_URL + "/config", getConfig());
  return response.data;
}

async function setLegalStatus(userId) {
  await msal.refreshToken();
  await axios.post(API_URL + '/users/' + userId + '/legalStatus', {}, getConfig());
  return;
}

async function setOrderLegalStatus(orderId) {
  await msal.refreshToken();
  await axios.post(API_URL + '/orders/' + orderId + '/legalStatus', {}, getConfig());
  return;
}

async function deleteLegalStatus(userId) {
  await msal.refreshToken();
  await axios.delete(API_URL + '/users/' + userId + '/legalStatus', getConfig());
  return;
}

async function getReferralCampaigns() {
  await msal.refreshToken();
  const response = await axios.get(API_URL + "/referralCampaigns", getConfig());
  return response.data.items;
}

async function createReferralCampaign(referralCampaign) {
  await msal.refreshToken();
  await axios.post(API_URL + "/referralCampaigns", referralCampaign, getConfig());
}

async function getInfluencerPromos() {
  await msal.refreshToken();
  const response = await axios.get(API_URL + "/influencerPromos", getConfig());
  return response.data.items;
}

async function createInfluencerPromo(influencerPromo) {
  await msal.refreshToken();
  await axios.post(API_URL + "/influencerPromos", influencerPromo, getConfig());
}

async function updateSkill(id, data, translations) {
  await msal.refreshToken();
  // console.log(id, min);
  const response = await axios.put(
    API_URL + "/skills/" + id,
    { data, translations },
    getConfig()
  );
  return response.data;
}

async function coverExpenses(id) {
  await axios.delete(
    API_URL + "/orders/" + id + "/expenses",
    getConfig()
  );
}

async function clearExpenses(id) {
  await axios.delete(
    API_URL + "/orders/" + id + "/paymentAmount",
    getConfig()
  );
}

async function setDiscount(id, amount) {
  await axios.put(
    API_URL + "/orders/" + id + "/discount",
    {
      discountAmount: amount
    },
    getConfig()
  );
}

async function updateProTotal(id, amount) {
  await axios.put(
    API_URL + "/orders/" + id + "/proTotal",
    { proTotal: amount },
    getConfig()
  );
}

async function convertToArrival(id) {
  await axios.put(
    API_URL + "/orders/" + id + "/convertOrderToArrival",
    {},
    getConfig()
  );
}

async function updateClientInvoiceDetails(id, details) {
  await axios.put(
    API_URL + "/orders/" + id + "/clientInvoiceDetails",
    details,
    getConfig()
  );
}

async function createSkill(data, translations) {
  await msal.refreshToken();
  // console.log(id, min);
  const response = await axios.post(
    API_URL + "/skills/new",
    { data, translations },
    getConfig()
  );
  return response.data;
}

async function createJob(jobId, data) {
  await msal.refreshToken();
  // console.log(id, min);
  const response = await axios.post(
    API_URL + "/jobs/" + jobId,
    { data },
    getConfig()
  );
  return response.data;
}

async function createNewsArticle(slug, data) {
  await msal.refreshToken();
  // console.log(id, min);
  const response = await axios.post(
    API_URL + "/news/" + slug,
    { data },
    getConfig()
  );
  return response.data;
}

async function publishNewTerms(data) {
  await msal.refreshToken();
  // console.log(id, min);
  const response = await axios.post(
    API_URL + "/terms/publish",
    { data },
    getConfig()
  );
  return response.data;
}

async function postRevolutFile(month, accountType, formdata) {
  const response = await axios.post(
    API_URL + '/month/' + month + '/revolut-to-csv/' + accountType,
    formdata,
    getConfig({
      'Content-Type': 'multipart/form-data'
    })
  );
  return response.data;
}

async function postStripeFile(month, accountType, formdata) {
  const response = await axios.post(
    API_URL + '/month/' + month + '/stripe-to-xml/' + accountType,
    formdata,
    getConfig({
      'Content-Type': 'multipart/form-data'
    })
  );
  return response.data;
}

async function generateDiscountsReport(month, params = {}) {
  await msal.refreshToken();
  // console.log(id, min);
  const response = await axios.post(
    API_URL + '/month/' + month + '/discounts',
    params,
    getConfig()
  );
  return response.data;
}

//month/:month/company-csv/:companyId
async function generateCompanyCsvReport(month, companyId) {
  await msal.refreshToken();
  // console.log(id, min);
  const response = await axios.post(
    API_URL + '/month/' + month + '/company-csv/' + companyId,
    {},
    getConfig()
  );
  return response.data;
}

//month/:month/company-xls/:companyId
async function generateCompanyXlsReport(month, companyId) {
  await msal.refreshToken();
  // console.log(id, min);
  const response = await axios.post(
    API_URL + '/month/' + month + '/company-xls/' + companyId,
    {},
    getConfig()
  );
  return response.data;
}
//company-department-xls
async function generateCompanyDepartmentXlsReport(month, companyId, params) {
  await msal.refreshToken();
  // console.log(id, min);
  const response = await axios.post(
    API_URL + '/month/' + month + '/company-department-xls/' + companyId,
    params,
    getConfig()
  );
  return response.data;
}

async function sendDepartmentReport(month, companyId, body) {
  await msal.refreshToken();
  // console.log(id, min);
  const response = await axios.post(
    API_URL + '/month/' + month + '/send-orders-report/' + companyId,
    body,
    getConfig()
  );
  return response.data;
}


async function createBlogArticle(slug, data) {
  await msal.refreshToken();
  // console.log(id, min);
  const response = await axios.post(
    API_URL + "/articles/" + slug,
    { data },
    getConfig()
  );
  return response.data;
}

async function addSaasPartner(proId, companyId) {
  await msal.refreshToken();
  // console.log(id, min);
  const response = await axios.post(
    API_URL + "/company/" +  companyId + '/saasPro/' + proId,
    {  },
    getConfig()
  );
  return response.data;
}

async function getTranslations() {
  await msal.refreshToken();
  const response = await axios.get(API_URL + "/translations", getConfig());
  return response.data;
}

async function getChat(taskId) {
  await msal.refreshToken();
  const response = await axios.get(
    API_URL + "/tasks/" + taskId + "/chat",
    getConfig()
  );
  return response.data;
}

async function getNote(collection, objectId) {
  await msal.refreshToken();
  const response = await axios.get(
    API_URL + "/notes/" + collection + "/" + objectId,
    getConfig()
  );
  return response.data;
}

async function getCallcentreConfig() {
  await msal.refreshToken();
  const response = await axios.get(
    API_URL + "/callcentre/config",
    getConfig()
  );
  return response.data;
}

async function getCallcentreLogs(params) {
  const encodedParams = Object.keys(params)
    .filter(key => params[key])
    .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(params[key]))
    .join('&');
  await msal.refreshToken();
  const response = await axios.get(
    API_URL + "/callcentre/logs?" + encodedParams,
    getConfig()
  );
  return response.data;
}

/*
export interface UpdateCallcentreConfigParam {
  agent: string;
  phoneNumber: string;
  destinationPhoneNumber: string;
}*/
async function updateCallcentreConfig(agent, phoneNumber, destinationPhoneNumber) {
  await msal.refreshToken();
  const data = {
    agent,
    phoneNumber,
    destinationPhoneNumber
  }
  const response = await axios.put(API_URL + "/callcentre/config", data, getConfig());
  return response.data;
}

async function updateCallcentreRouting(phoneNumbers, stickyMode = false) {
  await msal.refreshToken();
  const data = {
    phoneNumbers,
    stickyMode
  }
  const response = await axios.put(API_URL + "/callcentre/routing", data, getConfig());
  return response.data;
}

async function getInvoice(orderId) {
  await msal.refreshToken();
  const response = await axios.get(
    API_URL + "/orders/" + orderId + "/getInvoice",
    getConfig()
  );
  return response.data;
}

async function regenerateInvoice(orderId) {
  await msal.refreshToken();
  const response = await axios.get(
    API_URL + "/orders/" + orderId + "/regenerateInvoice",
    getConfig()
  );
  return response.data;
}

async function getAudit(type = "users", objectId = "") {
  await msal.refreshToken();
  objectId = objectId ? "/" + objectId : "";
  const response = await axios.get(API_URL + "/events/" + type + objectId, getConfig());
  return response.data;
}

async function deleteAudit(type = "users", objectId = "") {
  await msal.refreshToken();
  objectId = objectId ? "/" + objectId : "";
  const response = await axios.delete(API_URL + "/events/" + type + objectId, getConfig());
  return response.data;
}

async function deleteUser(userId) {
  await msal.refreshToken();
  const response = await axios.delete(API_URL + "/users/" + userId, getConfig());
  return response.data;
}

async function deleteCompany(companyId) {
  await msal.refreshToken();
  const response = await axios.delete(API_URL + "/companies/" + companyId, getConfig());
  return response.data;
}

async function deleteInvoice(invoiceId) {
  await msal.refreshToken();
  const response = await axios.delete(API_URL + "/invoices/" + invoiceId, getConfig());
  return response.data;
}

async function registerInvoice(invoiceId) {
  await msal.refreshToken();
  const response = await axios.get(
    API_URL + "/invoices/" + invoiceId + "/registerInvoice",
    getConfig()
  );
  return response.data;
}

async function generatePdf(invoiceId) {
  await msal.refreshToken();
  const response = await axios.get(
    API_URL + "/invoices/" + invoiceId + "/generateInvoicePdf",
    getConfig()
  );
  return response.data;
}

async function sendProEmail(invoiceId) {
  await msal.refreshToken();
  const response = await axios.get(
    API_URL + "/invoices/" + invoiceId + "/sendProEmail",
    getConfig()
  );
  return response.data;
}

async function sendSms(phoneNumber, text) {
  await msal.refreshToken();
  const response = await axios.post(
    API_URL + "/sms",
    {phoneNumber, text},
    getConfig()
  );
  return response.data;
}

async function sendClientEmail(invoiceId) {
  await msal.refreshToken();
  const response = await axios.get(
    API_URL + "/invoices/" + invoiceId + "/sendClientEmail",
    getConfig()
  );
  return response.data;
}

export default {
  assignPhoneNumber,
  getProDates,
  getSkillDates,
  getUsersByIds,
  saveNote,
  getPros,
  getProsStartedVerification,
  getClients,
  getCompany,
  getAudit,
  getChat,
  getNote,
  getOrders,
  getActiveOrders,
  getIssuesOrders,
  getOpenOrders,
  getCancelledOrders,
  getDrafts,
  getClosedOrders,
  addSaasPartner,
  getTasks,
  getTasksByIds,
  getReviewsByIds,
  getInvoicesByIds,
  getUsers,
  getAllUsers,
  getVerifications,
  searchUsers,
  searchOrders,
  reopenTask,
  getUser,
  getServices,
  getReferralCampaigns,
  cancelAutopayment,
  createReferralCampaign,
  getInfluencerPromos,
  createInfluencerPromo,
  verifyUser,
  promoteUser,
  sendInvoice,
  sendPayment,
  getTranslations,
  transfer,
  coverExpenses,
  updateSkill,
  getInvoice,
  registerInvoice,
  generatePdf,
  sendProEmail,
  removeDeletionRequest,
  sendNotifications,
  sendClientEmail,
  createJob,
  charge,
  getOrder,
  getTask,
  cancelOrder,
  rejectTask,
  deleteAudit,
  deleteUser,
  disableOrders,
  createSkill,
  overrideVerification,
  removeVerification,
  giveDiscount,
  removePassbase,
  getJobs,
  setBusinessSkills,
  getContactsByIds,
  clearExpenses,
  addNoteMessage,
  getContacts,
  getCompanies,
  getCarts,
  getCart,
  getCompanyMembers,
  getCompanyContacts,
  setAsSaasCandidate,
  getCompanyInvoices,
  generateCompanyReport,
  getCompanyReports,
  sendCompanyReport,
  getNews,
  getTerms,
  getArticles,
  createNewsArticle,
  createBlogArticle,
  generateDiscountsReport,
  postRevolutFile,
  postStripeFile,
  registerPayment,
  generateCompanyCsvReport,
  saveCompany,
  saveCompanyJobConfig,
  deleteCompany,
  deleteInvoice,
  resendInvite,
  publishNewTerms,
  deleteLegalStatus,
  inititateB2bOnboarding,
  removeB2bStatus,
  updateProTotal,
  getCallcentreConfig,
  updateCallcentreConfig,
  getCallcentreLogs,
  updateCallcentreRouting,
  regenerateInvoice,
  searchUsersByLocation,
  getPlatformConfig,
  setLegalStatus,
  getOffenders,
  getDisputedOrders,
  setOrderLegalStatus,
  sendSms,
  updateClientInvoiceDetails,
  generateCompanyXlsReport,
  sendDepartmentReport,
  generateCompanyDepartmentXlsReport,
  setDiscount,
  getPinnedOrders,
  addDebt,
  getDebtors,
  updateUserAddress,
  updatePhoneNumber,
  getLocations,
  updateOrderAddress: updateOrderLocation,
  createTag,
  addCompanyDebt,
  convertToArrival
};
